<ng-container *ngIf="viewModel$ | async as viewModel">
  <div
    *ngIf="viewModel.showUnsavedChangesBanner"
    class="sticky-unsaved-changes-banner"
    [class.above-shared-job-overlay]="viewModel.aboveSharedJobOverlay"
  >
    <div>
      <i [ngClass]="viewModel.unsavedChangesBannerIcon"> </i>
      <span> Unsaved changes </span>
    </div>
    <div class="buttons-container">
      <button
        pButton
        class="p-button-text p-m-1 save-notification-text-btn"
        label="Discard"
        tooltipPosition="left"
        [disabled]="viewModel.discardChangesButtonDisabled"
        [pTooltip]="viewModel.discardChangesButtonTooltip"
        (click)="onDiscard()"
      ></button>
      <button
        pButton
        class="p-button-text p-m-1 save-notification-text-btn"
        label="Save"
        [disabled]="viewModel.saveChangesButtonDisabled"
        [pTooltip]="viewModel.saveChangesButtonTooltip"
        (click)="onSave()"
      ></button>
    </div>
  </div>
</ng-container>
